import { Button } from "@mui/material";
import React from "react";
import { BiSortAlt2 } from "react-icons/bi";
import FilterIcon from "../../../../../assets/icons/filterIcon";
import { useSearchParams } from "react-router";

interface FilterAndSortButtonProps {
  handleClick: (e: any, label: string) => void;
  sx: React.CSSProperties;
  filterValue: string;
  sortByValue: string;
  sortByOrder: string;
}

const FilterAndSortButton: React.FC<FilterAndSortButtonProps> = ({
  handleClick,
  sx,
  filterValue,
  sortByOrder,
  sortByValue,
}) => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  return (
    <>
      {status === "active" && (
        <Button
          variant="outlined"
          sx={{
            ...sx,
            borderColor: filterValue ? "#318FE0" : "#D3D3DB",
            color:"#000000CC",
            fontSize:"16px",
            fontWeight:400


          }}
          startIcon={<FilterIcon />}
          onClick={(e) => handleClick(e, "filters")}
        >
          Filters
        </Button>
      )}
      <Button
        variant="outlined"
        sx={{
          ...sx,
          borderColor:
            sortByValue === "updated_at" && sortByOrder === "desc"
              ? "#D3D3DB"
              : "#318FE0",
              color:"#000000CC",
              fontSize:"16px",
              fontWeight:400
        }}
        startIcon={<BiSortAlt2 />}
        onClick={(e) => handleClick(e, "sort")}
      >
        Sort
      </Button>
    </>
  );
};

export default FilterAndSortButton;
